<template>
	<div>
		<div class="p-3 test-box-shadow border rounded-6 mb-3">
			<div class="border-bottom pb-2">
	      <p class="mb-1 sub-heading-1-1 color-black">{{data.name}}</p>
      	<p class="body-2-1 d-block mb-0 text-green">{{data.category.name}}</p>
	      <div class="py-1">
        	<p class="body-2-1 d-block mb-0 color-bold-light text-truncate-2">{{data.description}}</p>
	      </div>
	    </div>
	    <template v-if="is_variant > 0 && store.is_cart">
	    	<template v-for="(item,index) in data.variant_list">
					<!-- <ticket-variant :data="item" :ticket="ticket" @reset-item="transportChangeData('unselected')" :is_border="(index+1) != ticket.variants.length"></ticket-variant> -->
					<productExperienceVariant :data="item" :index="index" :product="data" :merchant="merchant"></productExperienceVariant>
				</template>
	    </template>
	    <div class="pt-3" :class="{'border-top':is_variant > 0 && store.is_cart}">
	      <div class="row slim-grid-row">
	        <div class="col-7">
        		<p class="mb-0 mt-2 sub-heading-1-2 text-color-orange">{{formatCurrency(main_price)}}</p>
	        </div>
	        <div class="col-5 text-center">
	        	<button v-if="data.availability <= 0 || is_all_variant_oos" class="btn w-100 body-2-4 rounded-10 py-2 text-center text-green"style="background-color: #EFEFEF" >{{$t('merchant.out-of-stock')}}</button>
	        	<template v-else>
	            <button v-if="!store.is_cart" class="bg-orange btn w-100 body-2-4 rounded-10 py-2 text-center text-white" style="height: 47px;" @click="changeQtyProduct('plus')">{{$t('general.select')}}</button>
	            <template v-else>
	            	<template v-if="is_variant">
	            		<button class="btn w-100 body-2-4 rounded-10 py-2 text-center text-green" style="background-color: #EFEFEF;height: 47px;" @click="cancelSelectProduct()">{{$t('general.cancel')}}</button>
	            	</template>
	            	<template v-else>
	            		<div class="plus-min-set mb-2">
	            			<div v-if="store.is_cart" class="d-inline-block mr-1 border-green box-dein" @click="changeQtyProduct('minus')">
	            				<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path class="fill-primary" d="M12.8333 8.57332C12.8333 8.84947 12.6094 9.07332 12.3333 9.07332H1.66663C1.39048 9.07332 1.16663 8.84947 1.16663 8.57332V7.23999C1.16663 6.96385 1.39048 6.73999 1.66663 6.73999H12.3333C12.6094 6.73999 12.8333 6.96385 12.8333 7.23999V8.57332Z" fill="#26B11D"/>
											</svg>
	            			</div>

					          <div class="d-inline-block border-none border-bottom-green text-center body-2-4 counter" style="width:45px;">
					          	{{store.data.qty}}
					          </div>
					          <div v-if="store.data.qty < data.availability" class="d-inline-block ml-1 border-green box-dein" @click="changeQtyProduct('plus')">
	            				<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" style="padding-bottom: 2px;">
												<path class="fill-primary" d="M14 8.40662C14 8.68276 13.7761 8.90662 13.5 8.90662H8.5C8.22386 8.90662 8 9.13047 8 9.40662V14.4066C8 14.6828 7.77614 14.9066 7.5 14.9066H6.5C6.22386 14.9066 6 14.6828 6 14.4066V9.40662C6 9.13047 5.77614 8.90662 5.5 8.90662H0.5C0.223857 8.90662 0 8.68276 0 8.40662V7.40662C0 7.13047 0.223858 6.90662 0.5 6.90662H5.5C5.77614 6.90662 6 6.68276 6 6.40662V1.40662C6 1.13047 6.22386 0.906616 6.5 0.906616H7.5C7.77614 0.906616 8 1.13047 8 1.40662V6.40662C8 6.68276 8.22386 6.90662 8.5 6.90662H13.5C13.7761 6.90662 14 7.13047 14 7.40662V8.40662Z" fill="#26B11D"/>
											</svg>
	            			</div>
					          <img v-else src="../../../../assets/img/icon/increment-disabled.png" class="d-inline-block ml-1" width="29" style="padding: 7px;border-radius: 5px;border:1px solid #777;background-color: #efefef;">
					        </div>
					        <p v-if="store.data.qty >= data.availability" class="mb-0 body-3-1 text-danger">{{$t('hotel.concierge.fitur.experience.only')}} {{data.availability}} {{$t('hotel.concierge.fitur.experience.stock-available')}}</p>
	            	</template>
	            </template>
	          </template>
	        </div>
	      </div>
	    </div>
		</div>
		<popupWarningAddProduct v-if="show_popup" @close="show_popup = false"></popupWarningAddProduct>
	</div>
</template>
<script>
	import {formatCurrency,calculateFinalPriceConcierge} from '@/utils/index.js';
	import {mapGetters,mapMutations} from "vuex";
  import productExperienceVariant from '@/components/hotel/concierge/general/productExperienceVariant'

	export default{
		props:['data','merchant'],
		components:{
			productExperienceVariant
		},
		data(){
			return{
        show_popup: false
			}
		},
		computed:{
			store(){
				let data = {
					is_cart: false,
					data: {}
				}	
				let record = this.getConciergeOrder().experience.cart.findIndex(x=>x.product.data.id == this.data.id)

				if(record != -1){
					data.is_cart = true
					data.data = this.getConciergeOrder().experience.cart[record]
				}

				return data
			},
			is_variant(){
				return this.data.variant_list.length > 0 ? true : false
			},
			main_price(){
				let price = this.is_variant ? this.data.variant_list[0].price : this.data.price
				return calculateFinalPriceConcierge(price)
			},
			is_all_variant_oos(){ //oos = out_of_stock
				if(!this.is_variant){
					return false
				}else{
					let total_avbl_variant = this.data.variant_list.filter(x=>x.availability>0)
					return total_avbl_variant.length == 0 ? true : false
				}
			}
		},
		methods:{
			...mapGetters(['getMerchant','getConciergeOrder','getConciergeReservation']),
      ...mapMutations(['setConciergeOrderExperience','removeConciergeOrderExperience','resetConciergeOrderExperience']),
			formatCurrency(data){
				return formatCurrency(data)
			},

			// FIX
			changeQtyProduct(type){
        let params = {
        	merchant: this.merchant,
          product: this.data,
          variant: {},
          qty: this.store.is_cart ? this.store.data.qty : 0
        }
        if(this.store.data.qty == 1 && type == 'minus'){
          this.removeConciergeOrderExperience(params)
        }else{
          if(type == 'minus'){
            params.qty--
          }else{
            params.qty++
            if(this.is_variant){
            	let variant_selected = this.data.variant_list.filter(x=>x.availability>0)
          		params.variant = variant_selected[0] 	
            }
          }
          this.setConciergeOrderExperience(params)
        }
      },
      cancelSelectProduct(){
      	this.resetConciergeOrderExperience(this.data.id)
      }
		}
	}
</script>
<style scoped>
	.destinations-dot{
		height: 37px;
		border-left: 1px dashed rgb(210, 206, 206);
		border-right: 1px dashed rgb(210, 206, 206);
		width:0px;
	}
	.test-box-shadow{
		box-shadow: 0 1px 5px 0 rgba(0,0,0,0.2);
	}
  .break {
    background-color: #e9ebf2;
    height: 6px;
    border-top: 1px solid #e2e2e2;
  }

  .color-black {
    color: #000 !important;
  }

  .color-bold-light {
    color: #000000A6;
  }

  .plus-min-set input {
    margin-top: 10px;
  }

  .w-85{
  	width: 85% !important;
  }
  .box-dein{
  	border-radius: 5px!important;
  	width: 28px;
  	height: 28px;
  }

	@media only screen and (max-width: 321px){
    .counter{
      width: 25px !important;
    }
  }

  /*@media only screen and (min-width: 600px){
    .counter{
      text-align: right !important;
    }
  }*/
</style>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/productExperience.vue